export default {
  description: 'Käytä koodia {{code}} saadaksesi alennuksen seuraavasta {{count}} tilauksesta, kun tilaat täältä.',
  discounts: {
    percentage: '{{discount}}%',
    fixed: '{{discount}}',
  },
  list: {
    item: {
      order: '{{orderNumber}}. tilaus',
    },
  },
  savings: {
    percentage: 'Säästät yhteensä {{totalSaved}} %',
    fixed: 'Säästät yhteensä {{totalSaved}}',
  },
  apply: 'Käytä',
  applied: 'Käytetty',
  remove: 'Poista',
  custom_button: {
    done: 'Valmis',
  },
};
